var _defs, _rect, _g, _g2, _g3, _circle, _g4, _rect2, _g5, _path, _g6, _circle2, _g7, _path2, _path3, _path4, _g8, _circle3, _g9, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05BiasDetectionandCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12 {\n        fill: #f6f6e0;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-2 {\n        stroke-width: 1.6px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #fff;\n        stroke-miterlimit: 101.79;\n      }\n\n      .cls-3 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 182.16,
    cy: 104.7,
    r: 20.26,
    transform: "translate(73.53 284.54) rotate(-88.76)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1786.02,
    y1: -479.74,
    x2: 1786.26,
    y2: -479.74,
    gradientTransform: "translate(5000425.09 -18615429) rotate(90) scale(10422.94 -10422.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1779.51,
    y1: -465.76,
    x2: 1779.75,
    y2: -465.76,
    gradientTransform: "translate(-78799.05 301887.29) rotate(-90) scale(169.58 -169.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.48,30.06L143.08,9.54s-55.71,213.67,161.26,203.69l10.48-144.25-20.34-38.91Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1786,
    y1: -479.73,
    x2: 1786.25,
    y2: -479.73,
    gradientTransform: "translate(18615537.69 5000274.85) rotate(-180) scale(10422.94 -10422.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1782.83,
    y1: -478.35,
    x2: 1783.08,
    y2: -478.35,
    gradientTransform: "translate(-632637.61 -1223090.42) rotate(47.63) scale(746.07 -746.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 302.72,
    cy: 59.04,
    r: 22.81,
    transform: "translate(106.11 296.67) rotate(-61.43)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1786.03,
    y1: -479.77,
    x2: 1786.27,
    y2: -479.77,
    gradientTransform: "translate(18615961.3 5000613.32) rotate(-180) scale(10422.94 -10422.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1776.03,
    y1: -468.3,
    x2: 1776.27,
    y2: -468.3,
    gradientTransform: "translate(-304954.17 -187473.59) rotate(16.79) scale(195.04 -195.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.69,
    y: 29.27,
    width: 60.9,
    height: 56.16,
    transform: "translate(-2.02 13.32) rotate(-2.28)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1785.88,
    y1: -479.79,
    x2: 1786.12,
    y2: -479.79,
    gradientTransform: "translate(5001241.05 -18614003.69) rotate(90) scale(10422.92 -10422.9)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1780.44,
    y1: -473.16,
    x2: 1780.68,
    y2: -473.16,
    gradientTransform: "translate(-578564.45 301236.78) rotate(-42.37) scale(354.2 -354.2)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "356.55 55.25 342.78 59.47 329.2 -.32 338.64 -3.21 356.55 55.25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1786.04,
    y1: -479.78,
    x2: 1786.28,
    y2: -479.78,
    gradientTransform: "translate(18616127.12 5000671.9) rotate(-180) scale(10422.94 -10422.89)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1779.42,
    y1: -467.41,
    x2: 1779.66,
    y2: -467.41,
    gradientTransform: "translate(-390249.07 -117527.67) rotate(2.03) scale(221.7 -221.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 349.91,
    cy: 57.17,
    r: 12.14,
    transform: "translate(148.19 348.74) rotate(-64.6)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1786.04,
    y1: -479.78,
    x2: 1786.28,
    y2: -479.78,
    gradientTransform: "translate(18616130.11 5000754.12) rotate(-180) scale(10422.94 -10422.89)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1765.93,
    y1: -457.45,
    x2: 1766.17,
    y2: -457.45,
    gradientTransform: "translate(-161386.19 -98264.24) rotate(16.77) scale(103.75 -103.75)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.96,55.47l-65.43,113.34c-2.92,5.06-2.92,11.29,0,16.34,2.92,5.06,8.32,8.17,14.16,8.17h130.88c5.84,0,11.24-3.12,14.16-8.17,2.92-5.06,2.92-11.29,0-16.34l-65.45-113.34c-2.92-5.06-8.32-8.17-14.16-8.17s-11.24,3.12-14.16,8.17Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1785.99,
    y1: -479.72,
    x2: 1786.23,
    y2: -479.72,
    gradientTransform: "translate(5000335.01 -18615081.09) rotate(90) scale(10422.94 -10422.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1162",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6817",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1782.61,
    y1: -478.12,
    x2: 1782.85,
    y2: -478.12,
    gradientTransform: "translate(-1103063.29 570979.98) rotate(-42.37) scale(673.02 -673.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6817"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.99,
    cy: 124.96,
    r: 13.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1786.02,
    y1: -479.77,
    x2: 1786.25,
    y2: -479.77,
    gradientTransform: "translate(5000925.47 -18615386.18) rotate(90) scale(10422.94 -10422.89)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1763.53,
    y1: -467.87,
    x2: 1763.77,
    y2: -467.87,
    gradientTransform: "translate(-174482.44 117368.72) rotate(-48.71) scale(115.35 -115.35)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 174.6,
    cy: 55.2,
    r: 13.5,
    transform: "translate(114.29 228.1) rotate(-88.32)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1786.04,
    y1: -479.73,
    x2: 1786.28,
    y2: -479.73,
    gradientTransform: "translate(5000354.62 -18615676.68) rotate(90) scale(10422.94 -10422.89)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1764.57,
    y1: -471.96,
    x2: 1764.81,
    y2: -471.96,
    gradientTransform: "translate(-175053.29 117078.22) rotate(-48.71) scale(115.35 -115.35)",
    xlinkHref: "#linear-gradient-6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -3.59,
    y: -3.39,
    width: 487.17,
    height: 226.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 161.9,
    y: 84.44,
    width: 40.52,
    height: 40.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.9,
    y: 84.44,
    width: 40.52,
    height: 40.52
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 94.22,
    y: 14.89,
    width: 217.14,
    height: 215.68,
    transform: "translate(65.69 316.1) rotate(-85.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 94.22,
    y: 14.89,
    width: 217.14,
    height: 215.68,
    transform: "translate(65.69 316.1) rotate(-85.85)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 279.91,
    y: 36.22,
    width: 45.63,
    height: 45.63,
    transform: "translate(106.11 296.67) rotate(-61.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.91,
    y: 36.22,
    width: 45.63,
    height: 45.63,
    transform: "translate(106.11 296.67) rotate(-61.43)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 302.72,
    cy: 59.04,
    r: 22.81,
    transform: "translate(106.11 296.67) rotate(-61.43)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.69,
    y: 29.27,
    width: 60.9,
    height: 56.16,
    transform: "translate(-2.02 13.31) rotate(-2.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 302.69,
    y: 29.27,
    width: 60.9,
    height: 56.16,
    transform: "translate(-2.02 13.31) rotate(-2.28)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 302.68,
    y: 29.27,
    width: 60.9,
    height: 56.16,
    transform: "translate(-2.02 13.31) rotate(-2.28)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 315.57,
    y: 3.59,
    width: 53.07,
    height: 50.59,
    transform: "translate(153.14 315.52) rotate(-61.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 315.57,
    y: 3.59,
    width: 53.07,
    height: 50.59,
    transform: "translate(153.14 315.52) rotate(-61.43)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.54,55.25l-13.76,4.22L329.2-.32l9.44-2.89,17.9,58.46Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 337.77,
    y: 45.03,
    width: 24.27,
    height: 24.27,
    transform: "translate(132.37 337.14) rotate(-61.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 337.77,
    y: 45.03,
    width: 24.27,
    height: 24.27,
    transform: "translate(132.37 337.14) rotate(-61.43)"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 349.9,
    cy: 57.17,
    r: 12.14,
    transform: "translate(132.37 337.13) rotate(-61.43)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 141.62,
    y: 47.3,
    width: 165.03,
    height: 146.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 141.62,
    y: 47.3,
    width: 165.03,
    height: 146.03
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.96,55.47l-65.43,113.34c-2.92,5.06-2.92,11.29,0,16.34,2.92,5.06,8.32,8.17,14.16,8.17h130.88c5.84,0,11.24-3.12,14.16-8.17,2.92-5.06,2.92-11.29,0-16.34l-65.45-113.34c-2.92-5.06-8.32-8.17-14.16-8.17s-11.23,3.12-14.16,8.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.3,170.73c-.21-3.15.92-6.24,3.11-8.52s5.23-3.53,8.39-3.45c7.05,0,11.5,4.86,11.65,11.97.2,3.18-.95,6.29-3.17,8.57-2.22,2.28-5.3,3.51-8.48,3.4-3.17.11-6.23-1.13-8.43-3.41-2.2-2.28-3.32-5.39-3.08-8.55ZM214.58,149.11l-2.75-71.46h19.92l-2.75,71.46h-14.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.54,168.5c-.2-3.15.93-6.24,3.12-8.51,2.19-2.27,5.23-3.53,8.38-3.45,7.05,0,11.5,4.86,11.65,11.97.19,3.17-.96,6.28-3.18,8.56-2.22,2.28-5.29,3.51-8.47,3.41-3.16.1-6.22-1.14-8.42-3.42-2.19-2.28-3.32-5.39-3.09-8.55ZM216.85,146.87l-2.77-71.48h19.94l-2.75,71.48h-14.42Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 297.5,
    y: 111.46,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 297.5,
    y: 111.46,
    width: 27,
    height: 27
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 310.99,
    cy: 124.62,
    r: 13.5
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.1,
    y: 41.7,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 161.1,
    y: 41.7,
    width: 27,
    height: 27
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 174.6,
    cy: 55.2,
    r: 13.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05BiasDetectionandCorrection);
export default __webpack_public_path__ + "static/media/05 Bias Detection and Correction.58d2410dd07bd54aa6f603e812615a8b.svg";
export { ForwardRef as ReactComponent };